import { variant } from 'styled-system';
import { WrapperProps } from '../Wrapper/Wrapper';
import styled from '../../../theme/theme';
import { BaseIcon, BaseIconProps } from '../Icon/Icon';
import { ColorProps } from '../../../theme/styledProps';
import { TruncatedText } from '../Text/TruncatedText';

export type ListItemVariant = 'default' | 'error' | 'selected' | 'inactive';

export interface ListItemWrapperProps extends WrapperProps {}

interface ListItemIconProps extends BaseIconProps {
  variant: ListItemVariant;
  disabled?: boolean;
}

export const ListItemText = styled(TruncatedText)<any>(
  {
    fontWeight: 500,
  },

  ({ disabled }) =>
    variant<ColorProps, ListItemVariant>({
      variants: {
        default: {
          color: disabled ? 'neutral.400' : 'neutral.700',
        },

        error: {
          color: disabled ? 'neutral.400' : 'error.600',
        },

        selected: {
          color: disabled ? 'neutral.400' : 'primary.500',
        },

        inactive: {
          color: disabled ? 'neutral.400' : 'neutral.700',
        },
      },
    }),
);

export const ListItemIcon = styled(BaseIcon).attrs({ fontSize: 'h6', my: '2', mr: '8' })<
  ListItemIconProps
>(
  {
    flexShrink: 0,
  },
  ({ disabled }) =>
    variant<ColorProps, ListItemVariant>({
      variants: {
        default: {
          color: disabled ? 'neutral.400' : 'neutral.500',
        },

        error: {
          color: disabled ? 'neutral.400' : 'error.600',
        },

        selected: {
          color: disabled ? 'neutral.400' : 'primary.500',
        },

        inactive: {
          color: 'transparent',
        },
      },
    }),
);
